<nav class="bottom-navbar"
     data-testid="footer-navigation-bar">
  @for (item of menuItems; track item.tabName) {
    <a class="nav-item"
       [href]="'/' + item.route"
       [attr.data-testid]="'footer-nav-item-' + item.tabName"
       [ngClass]=" { 'inactive': item.tabName !== defaultItem }"
       (click)="item.tabName !== defaultItem && navigate($event, item)">
      @if(item.itemIconUri){
        <img [src]="item.itemIconUri"
             alt="{{ item.itemText }}" />
      }
      @else if (item.itemIconUriActive && item.itemIconUriInactive) {
        <img [src]="item.tabName === defaultItem ? item.itemIconUriActive : item.itemIconUriInactive"
             alt="{{ item.itemText }}" />
      }
      @else if (item.itemIconClass) {
        <i [class]="item.itemIconClass"
           aria-hidden="true"></i>
      }
      <span class="nav-item-label">{{ item.itemText }}</span>
    </a>
  }
</nav>